// A task's list as the panel holds it: the server's copy, plus each write applied to the
// screen the moment it is made and then confirmed by a quiet reload. The reload is what
// brings back the server's summary — the panel never counts the bar itself.
import { useCallback, useEffect, useState } from 'react';
import useAsync from '../../hooks/useAsync';
import { taskListsApi } from '../../api';

export default function useListData(taskId, onChanged) {
  const { data, loading, error, reload } = useAsync(() => taskListsApi.get(taskId), [taskId]);
  const [local, setLocal] = useState(null);
  const [failure, setFailure] = useState(null);
  useEffect(() => { setLocal(data); }, [data]);

  // `mutate` reshapes the local copy (may be omitted); `request` is the write.
  const act = useCallback(async (request, mutate) => {
    setFailure(null);
    if (mutate) setLocal((cur) => (cur ? mutate(cur) : cur));
    try {
      return await request();
    } catch (e) {
      setFailure(e);
      return null;
    } finally {
      reload();
      if (onChanged) onChanged();
    }
  }, [reload, onChanged]);

  const patchItem = (id, patch) => (cur) => ({
    ...cur,
    list: { ...cur.list, items: cur.list.items.map((i) => (i.id === id ? { ...i, ...patch, cells: { ...i.cells, ...(patch.cells || {}) } } : i)) },
  });

  return { data: local, loading, error, failure, act, patchItem, reload };
}
